var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"rbvCheckBox material-icons",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.onClick($event)}}},[_vm._v(_vm._s(_vm.stateIcon))])}
var staticRenderFns = []

export { render, staticRenderFns }